import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [ok, setOk] = useState(null);

  useEffect(() => {
    if (loading) return;
    if (user) { setOk(true); return; }
    setOk(false);
    navigate("/admin/login", { replace: true, state: { from: location.pathname } });
  }, [user, loading, navigate, location.pathname, setOk]);

  if (loading || ok === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-ccc-ivory" data-testid="auth-loading">
        <div className="text-ccc-plum font-serif text-2xl">Loading...</div>
      </div>
    );
  }
  return ok ? children : null;
}
